import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuildImageComponent } from '../build-image/build-image.component';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CreateRegistryRequest } from 'src/app/core/models/repository';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-registry',
  templateUrl: './create-registry.component.html',
  styleUrl: './create-registry.component.scss'
})
export class CreateRegistryComponent implements OnInit {
 
  constructor(
    public dialog: MatDialogRef<BuildImageComponent>,
    private configEntityService: ConfigEntityService,
    private myElement: ElementRef,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { 
      name: string, 
      updateForm: boolean,
      isBuildAndPush: boolean
    }
  ) { }
  
  createRegistryForm: UntypedFormGroup;
  
  ngOnInit(): void {
    this.buildAndImageAndPushForm();
  }
  
  
  buildAndImageAndPushForm() {
    this.createRegistryForm = new UntypedFormGroup({
      name: new UntypedFormControl('', { validators: [Validators.required] }),
      port: new UntypedFormControl('', { validators: [Validators.required, Validators.pattern('^[0-9]*$')] }),
      restartPolicy: new UntypedFormControl('', { validators: [Validators.required] }),
      domain: new UntypedFormControl('localhost', { validators: [Validators.required] })
    });
  }
  
  onCancel() {
    this.dialog.close(false);
  }
  
  toogleDialog: boolean = false;
  toogleDialogMinMax() {
    this.toogleDialog = !this.toogleDialog;
    
    const currentElement = this.myElement.nativeElement;
    
    let dialogElement = currentElement.parentElement;
    while (dialogElement && !dialogElement.classList.contains('cdk-overlay-pane')) {
      dialogElement = dialogElement.parentElement;
    }
    
    if (!dialogElement) {
      console.error('Could not find parent overlay pane');
      return;
    }
    
    
    if(this.toogleDialog) {
      dialogElement.classList.add('minimize2');
      dialogElement.classList.remove('maximize');
    } else {
      dialogElement.classList.remove('minimize2');
      dialogElement.classList.add('maximize');
      
      setTimeout(() => {
        dialogElement.classList.remove('maximize');
      }, 300);
    }
  }
  
  createRegistry() {
    try{
      this.spinner.show("createRegistry");
      // Check if the form is valid
      if (!this.createRegistryForm.valid) {
        this.createRegistryForm.markAllAsTouched();
        this.spinner.hide("createRegistry");
        this.snackBar.open('Please fill in all required fields correctly.', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        }); 
        return;
      }

      const formValue = this.createRegistryForm.getRawValue();
      const request = {
        name: formValue.name,
        port: formValue.port,
        restartPolicy: formValue.restartPolicy,
        domain: formValue.domain,
        withHttps: true
      };
      this.configEntityService.createRegistry(request).subscribe({
        next: (response) => {
          this.spinner.hide("createRegistry");
          let message = JSON.parse(JSON.stringify(response)).message;
          this.snackBar.open(message, 'Close', {
            duration: 5000,
            panelClass: ['success-snackbar']
          });
          this.dialog.close(response);
        },
        error: (error) => {
          this.spinner.hide("createRegistry");
          console.error('Failed to create registry:', error);
        }
      });
    }
    catch(error) {
      this.spinner.hide("createRegistry");
      console.error('Error in createRegistry:', error);
      this.snackBar.open('Failed to create registry. Please try again.', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
      return;
    }
  }
}
